var getIdForModel = function (identifier) {
    if (!identifier) {
        return identifier;
    }
    if (typeof identifier === 'number') {
        return identifier;
    }
    if (isNaN(Number(identifier))) {
        return identifier;
    }
    return Number(identifier);
};
export default getIdForModel;
